import { message, Button, Col, ConfigProvider, Layout, Pagination, Popconfirm, Row, Statistic, Table, Input, Popover,} from 'antd'
import { Content } from 'antd/lib/layout/layout'

import { BACKEND_API_URL } from '../../../constants/constants'
import React, { useEffect, useRef, useState } from 'react'
import OAMSider from '../oam-sider'
import Cookies from 'js-cookie'
import { sendHttpPostRequest } from '../../../api/http-request'
import Search from 'antd/lib/input/Search'
import zhCN from 'antd/lib/locale/zh_CN'
import GlobalCss from '@/global.module.less'

import PublicTipModal from '@/pages/components/PublicTipModal/PublicTipModal'
import UserCard from '../user/oam-userinfo-card'

const statusMap = new Map([
  [1, '已下架'],
  [2, '已上架'],
])
const channelMap = new Map([
  ['爱数科', 1],
  ['爱数课', 2],
])

export interface Props {}

export const OAMProjectList: React.FC<Props> = (props) => {
  const [chapterResult, setChapterResult] = useState([] as any[]) // 当前显示的结果页
  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数
  const [totalCount, setTotalCount] = useState(0) // 搜索返回的结果数
  const [onlineCount, setOnlineCount] = useState(0) // 搜索返回的结果数

  const queryChannel = useRef(0) // 来源渠道
  const queryContent = useRef('') // 记录搜索串
  const order = useRef('') // 排序升序降序
  const order_by = useRef('') // 排序列
  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(10) // 记录当前每页展示数量

  const statusFilters = useRef([]) // 状态过滤项
  const channelFilters = useRef([]) // 渠道过滤项
  const userIsLogin = useRef(false) // 用户是否登录


  const newName = useRef('') // 名称
  const newDesc = useRef('') // 描述
  const [createModalVis, setCreateModalVis] = useState(false)
  const createOk = () => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      name: newName.current,
      description: newDesc.current,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('course/api/oam_create_project', data, (res) => {
      if (res.code == 0) {
        message.success('新建项目成功~')
        setCreateModalVis(false)
        queryProjectList()
      } else {
        message.error(res.message)
      }
    })
    newName.current = ''
    newDesc.current = ''
    
  }

  const createCancel = () => {
    setCreateModalVis(false)
    newName.current = ''
    newDesc.current = ''
  }
  
  useEffect(() => {
    queryProjectList()
  }, [])

  /**
   * 查询项目列表
   */
  const queryProjectList = () => {
    sendHttpPostRequest(
      'course/api/oam_query_project_list',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        page: page.current,
        pagesize: pageSize.current,
        status: JSON.stringify(statusFilters.current),
        query: queryContent.current,
      },
      queryChapterListCallback
    )
  }

  /**
   * 查询项目列表回调
   * @param response
   */
  const queryChapterListCallback = (response: any) => {
    // console.log(response)
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/oam_login?next=oam_project'
    } else if (response.is_ok == true) {
      // 成功
      setChapterResult(response.query_list)
      setResultSum(response.total_sum)
      setTotalCount(response.total_count)
      //setSysCount(response.sys_count);
      //setUserCount(response.user_count);
      setOnlineCount(response.online_count)
    } // else if (response.code == -501) {
    // 权限不足
    //window.location.href = '/oam_login?next=oam_chapter';
    //} else {
    //message.error(response.message);
    //}
  }

  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryProjectList()
  }

  /**
   * 删除项目
   */
  const deleteProject = (projectId: string | number) => {
    sendHttpPostRequest(
      'course/api/oam_delete_project',
      {
        sessionid: Cookies.get('sessionid'),
        project_id: projectId,
      },
      deleteProjectCallback
    )
  }

  /**
   * 删除项目回调
   * @param response
   */
  const deleteProjectCallback = (response: any) => {
    // console.log(response)
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/oam_login?next=oam_project'
    } else if (response.is_ok == true) {
      // 成功
      message.success('删除成功')
      queryProjectList()
      //setResultSum(response.total_sum);
      // setTotalCount(response.total_count);
      //setSysCount(response.sys_count);
      //setUserCount(response.user_count);
      // setOnlineCount(response.online_count);
    } /*else if (response.code == -501) {
            // 权限不足
            window.location.href = '/oam_login?next=oam_chapter';
        } */ else {
      message.error(response.message)
    }
  }

  //点击了查看按钮
  const onLookOverBtnClick = (event: any) => {
    //message.success('查看数据' + event.currentTarget.value)
    event.preventDefault()
    window.open('/oam_chapter_detail?id=' + event.currentTarget.value)
  }

  //点击了编辑按钮
  const onEditBtnClick = (event: any) => {
    //message.success('编辑数据' + event.currentTarget.value)
    event.preventDefault()
    window.open('/oam_project_edit?id=' + event.currentTarget.value)
  }

  //点击新建按钮
  const onCreateBtnClick = (event: any) => {
    //message.success('编辑数据' + event.currentTarget.value)
    event.preventDefault()
    sendHttpPostRequest(
      'course/api/oam_create_project',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.course_id) {
          window.open(`/oam_project_edit?id=${response.course_id}`)
        } else {
          message.destroy()
          message.error('创建失败')
        }
      }
    )
  }

  // 点击 删除
  const onDeleteBtnClick = (name: string, id: number) => {
    deleteProject(id)
  }

  // 点了上架按钮
  const onPutOnOffBtnClick = (project_id: string, statusStr: number) => {
    let url = 'course/api/oam_set_project_online'
    if (statusStr == 2) {
      url = 'course/api/oam_set_project_offline'
    }
    sendHttpPostRequest(
      url,
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: project_id,
      },
      (response: any) => {
        message.destroy()
        message.info(response.message)
        queryProjectList()
      }
    )
  }

  // 点击 公开 或 不公开
  const onPublicBtnClick = (projectId: number, publicStatus: number) => {
    publicStatus == 2 ? (publicStatus = 1) : (publicStatus = 2)
    sendHttpPostRequest(
      'course/api/oam_update_project',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: projectId,
        public_status: publicStatus,
      },
      (response: any) => {
        message.destroy()
        if (response.is_ok) {
          const _message = ''
          message.success(publicStatus == 2 ? '项目不公开' : '项目已公开')
          setTimeout(function () {
            queryProjectList()
          }, 1000)
        } else {
          message.error('设置公开状态失败了')
        }
      }
    )
  }

  // 渲染状态
  const renderStatus = (text: any, record: any) => {
    return <span>{statusMap.get(parseInt(text))}</span>
  }

  // 渲染操作
  const renderActions = (text: any, record: any) => {
    return (
      <>
        <Row justify="start" align="middle" gutter={[8, 5]} wrap={false}>
          {/*<Col style={{width:50}}><Button style={{borderRadius:20,fontSize:12}} size='small' id="lookover" value={record.id} type="default" onClick={onLookOverBtnClick} > 查 看 </Button></Col>*/}
          <Col >
            <Button
              style={{ borderRadius: 20}}
              //size="small"
              id="edit"
              value={record.id}
              type="dashed"
              onClick={onEditBtnClick}
            >
              {' '}
              编 辑{' '}
            </Button>{' '}
          </Col>
          {
            <Col>
              {' '}
              {parseInt(record.status) == 1 ? (
                <Button
                  style={{ borderRadius: 20}}
                  //size="small"
                  id="puton"
                  value={record.id}
                  type="primary"
                  onClick={onPutOnOffBtnClick.bind(
                    this,
                    record.id,
                    record.status
                  )}
                >
                  {' '}
                  上 架{' '}
                </Button>
              ) : (
                <Popconfirm
                  placement="top"
                  title={'确认下架项目"' + record.name + '"吗？'}
                  onConfirm={onPutOnOffBtnClick.bind(
                    this,
                    record.id,
                    record.status
                  )}
                  okText="确认"
                  cancelText="取消"
                >
                  <Button
                    style={{ borderRadius: 20, }}
                    //size="small"
                    id="putoff"
                    value={record.id}
                    type="primary"
                    danger
                  >
                    {' '}
                    下 架{' '}
                  </Button>
                </Popconfirm>
              )}
            </Col>
          }
          {
            <Col >
              <Popconfirm
                placement="top"
                title={'确认删除项目"' + record.name + '"吗？'}
                onConfirm={onDeleteBtnClick.bind(this, record.name, record.id)}
                okText="确认"
                cancelText="取消"
              >
                <Button
                  style={{ borderRadius: 20, }}
                  //size="small"
                  id="delete"
                  danger
                  value={record.id}
                >
                  {' '}
                  删 除{' '}
                </Button>
              </Popconfirm>
            </Col>
          }
          {parseInt(record.status) == 2 && (
            <Col style={{  }}>
              <Button
                style={{ borderRadius: 20, }}
                //size="small"
                id="edit"
                value={record.id}
                type="dashed"
                onClick={onPublicBtnClick.bind(
                  this,
                  record.id,
                  record.public_status
                )}
                danger
              >
                {' '}
                {record.public_status == 1 ? '已 ' : '未 '}公 开{' '}
              </Button>{' '}
            </Col>
          )}
        </Row>
      </>
    )
  }

  //点击了搜索按钮
  const onSearchBtn = (value: string) => {
    page.current = 1
    queryContent.current = value
    queryProjectList()
    //queryUserInfo();
  }

  // 表格发生变化
  const onTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      //order.current = sorter.order;
      //order_by.current = sorter.field;
    }
    if (filters.status) {
      //如果选择了过滤列
      statusFilters.current = filters.status
    } else {
      statusFilters.current = []
    }
    if (filters.channel_name) {
      channelFilters.current = filters.channel_name.map((element) => {
        return channelMap.get(element)
      })
    } else {
      channelFilters.current = []
    }
    page.current = 1
    queryProjectList()
    //queryUserInfo();
  }

  // 表格列
  const cols: any = [
    {
      title: '序号',
      dataIndex: 'id',
      key: 'id',
      width: 60,
      align: 'left',
    },
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      align: 'left',
      ellipsis: true,
      render: (text, record) => {
        return (
          //  <Tooltip title={record.name}>
          <span
            className={GlobalCss.link}
            onClick={() => window.open(`/project_main?project_id=${record.id}`)}
          >
            {record.name}
          </span>
          //  </Tooltip>
        )
      },
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
      width: 300,
      align: 'left',
      ellipsis: true,
    },
    {
      title: '创建者',
      dataIndex: 'creator_name',
      key: 'creator_name',
      width: 150,
      align: 'left',
      ellipsis: true,
      render: (text, record) => {
        return (
          <Row align="middle" wrap={false}>
            <Col flex="40px">
              <Popover
                arrowPointAtCenter={true}
                trigger="hover"
                placement="left"
                content={<UserCard user_id={record?.creator_id} />}
                title={null}
              >
                <img
                  onMouseOver={() => {}}
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 15,
                    cursor: 'pointer',
                  }}
                  src={
                    record?.creator_avatar?.startsWith('http')
                      ? record?.creator_avatar
                      : BACKEND_API_URL + record?.creator_avatar
                  }
                />
              </Popover>{' '}
            </Col>
            <Col flex="auto">
              <span>{text}</span>
            </Col>
          </Row>
        )
      },
  },
  {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      width: 200,
      align: 'left',
  },
  {
    title: '年付价格',
    dataIndex: 'annual_price_yuan',
    key: 'annual_price_yuan',
    width: 120,
    align: 'center',
    render: (text: any, record: any) => <span>¥{record?.annual_price_yuan || '99.80'}</span>,
  },

  {
    title: '镜像',
    dataIndex: 'env_name',
    key: 'env_name',
    align: 'center',
    width: 120,
    ellipsis: true,
    render: (t, r, i) => (
      <span
        className={GlobalCss.link}
        onClick={() =>
          window.open('/oam_image_preview?image_id=' + r.env_id)
        }
      >
        {t}
      </span>
    ),
  },
  
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 80,
      align: 'center',
      render: renderStatus,
      filters: [
        {
          text: '已下架',
          value: 1,
        },
        {
          text: '已上架',
          value: 2,
        },
      ],
      onFilter: (value: any, record: any) => true,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 340,
      ellipsis: false,
      align: 'center',
      fixed: 'right',
      render: renderActions,
    },
  ]

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={'2'} openKeys={['sub-project']}></OAMSider>
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: 30,
            paddingTop: 20,
          }}
        >
          <div style={{ paddingLeft: 30, paddingRight: 30 }}>
            <Row align="middle" gutter={16}>
              <Col flex="80px">
                <Statistic title="项目总数" value={totalCount} />
              </Col>
              <Col flex="80px">
                <Statistic title="已上架" value={onlineCount} />
              </Col>
              <Col flex="250px">
                <Search
                  placeholder="搜索项目"
                  style={{ width: 350 }}
                  enterButton={true}
                  onSearch={onSearchBtn}
                />
              </Col>

              <Col flex="auto" style={{ textAlign: 'right' }}>
                {' '}
                <Button
                  style={{ borderRadius: 20 }}
                  type={'primary'}
                  onClick={()=>{setCreateModalVis(true)}}
                >
                  {' '}
                  + 新 建
                </Button>
              </Col>
            </Row>

            <div style={{height:500}}
              className={GlobalCss.tableWrapper}
              //style={{ minHeight: 630 }}
            >
              <ConfigProvider locale={zhCN}>
                <Table
                  scroll={{ x: 800 }}
                  dataSource={chapterResult}
                  columns={cols}
                  rowKey={(record) => record.id}
                  pagination={false}
                  // bordered={true}
                  onChange={onTableChange}
                />
              </ConfigProvider>
            </div>

            <ConfigProvider locale={zhCN}>
              <div
                style={{
                  marginBottom: 30,
                  paddingTop: 30,
                  textAlign: 'center',
                }}
                className={'css.pagination'}
              >
                <Pagination
                  defaultCurrent={1}
                  total={resultSum}
                  current={page.current}
                  defaultPageSize={10}
                  hideOnSinglePage={true}
                  onChange={onPageChange}
                  showQuickJumper={true}
                  showTotal={(total) => `共 ${total} 项目`}
                  pageSizeOptions={['10', '20', '50', '100']}
                />
              </div>
            </ConfigProvider>
          </div>
        </Content>
        <PublicTipModal
          modalContent={<div>
            <Row align={'middle'} justify={'start'} className={GlobalCss.formRow}>
            <Col className={GlobalCss.requiredLabel}>名称</Col>
            <Col>
              <Input
                style={{
                  width: '300px',
                }}
                placeholder="请输入项目名称"
                maxLength={50}
                onChange={(e) => {
                 newName.current = e.target.value
                }}
              />
            </Col>
          </Row>
          <Row align={'top'} justify={'start'} className={GlobalCss.formRow} style={{marginTop:15}}>
            <Col className={GlobalCss.requiredLabel}>描述</Col>
            <Col>
              <Input.TextArea
                style={{
                  minHeight: '145px',
                  width: '300px',
                }}
                placeholder="请输入项目描述"
                onChange={(e) => {newDesc.current = e.target.value}}
              />
            </Col>
          </Row>
          </div>
          }
          modalTitle={'创建项目'}
          handleOk={createOk}
          handleCancel={createCancel}
          open={createModalVis}
          setOpen={setCreateModalVis}
        />

      </Layout>
    </Layout>
  )
}

export default OAMProjectList
